import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import i18n from 'kodyl-js/i18n/react';
import {
  cancelSubscription,
  unsubscribeManual,
  unsubscribeReason
} from 'app/redux/modules/subscriptions';

//TODO: create unsubscription object
const FOUND_DWELLING = 'FOUND_DWELLING';
const FOUND_NO_DWELLING = 'FOUND_NO_DWELLING';

@connect(
  ({ auth: { user }, subscriptions }) => ({ user, subscriptions }),
  { cancelSubscription, unsubscribeManual, unsubscribeReason }
)
@i18n
class Questionaire extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: {},
      foundDwelling: false,
      uuid: props.subscription || '',
      error: false
    };
  }

  handleSubmit = () => {
    const { values, uuid } = this.state;

    this.setState({ error: false });
    this.props.unsubscribeReason({ ...values, uuid }).then(action => {
      if (action && action.payload && action.payload.status === 'OK') {
        this.setState({
          uuid: action.payload.data.uuid
        });

        if (!/^FOUND_/.test(values.reason)) {
          const { setSubscription } = this.props;
          if (setSubscription) {
            setSubscription(null);
          }
        }
      }
      if (/FAIL/.test(action.type)) {
        this.setState({ error: true });
      }
      return action;
    });
  };

  setValue(name, value) {
    const values = {
      ...this.state.values,
      [name]: value
    };

    this.setState({ values }, () => {
      if (name === 'reason' && /^found-|FOUND_/.test(value)) {
        this.handleSubmit();
      }
    });
  }

  handleChange = ev => {
    const { target } = ev;
    const { type, name } = target;
    const value = type === 'checkbox' ? target.checked : target.value;

    this.setValue(name, value);
  };

  openSurvey = value => {
    this.setState({ foundDwelling: value });
    this.setValue('reason', value);
  };

  render() {
    const { foundDwelling, error } = this.state;

    return (
      <div>
        {!foundDwelling ? (
          <div>
            <strong style={{ marginBottom: '10px', display: 'block' }}>
              {this.i18n('Afmelder du, fordi du har fundet bolig?')}
            </strong>
            <div className="btn-group btn-group-justified">
              <a
                className="btn btn-default found"
                role="button"
                onClick={() => this.openSurvey(FOUND_DWELLING)}
              >
                Ja
              </a>
              <a
                className="btn btn-default not-found"
                role="button"
                onClick={() => this.openSurvey(FOUND_NO_DWELLING)}
              >
                Nej
              </a>
            </div>
            {error ? (
              <Alert bsStyle="danger">
                {this.i18n(
                  'Oops! Something went wrong. Please try again or reach out to our customer support.'
                )}
              </Alert>
            ) : null}
          </div>
        ) : null}
        {foundDwelling === FOUND_DWELLING ? (
          <div>
            <strong style={{ marginBottom: '10px', display: 'block' }}>
              {this.i18n('Where did you found the dwelling?')}
            </strong>
            <label>
              <input
                type="radio"
                name="reason"
                value="found-boligninja"
                onClick={this.handleChange}
              />{' '}
              {this.i18n('On Boligninja.dk')}
            </label>
            <br />
            <label>
              <input
                type="radio"
                name="reason"
                value="found-portal"
                onClick={this.handleChange}
              />{' '}
              {this.i18n('On another portal')}
            </label>
            <br />
            <label>
              <input
                type="radio"
                name="reason"
                value="found-facebook"
                onClick={this.handleChange}
              />{' '}
              {this.i18n('On Facebook')}
            </label>
            <br />
            <label>
              <input
                type="radio"
                name="reason"
                value="found-friends"
                onClick={this.handleChange}
              />{' '}
              {this.i18n('Through friends')}
            </label>
            <br />
            <label>
              <input
                type="radio"
                name="reason"
                value="found-other"
                onClick={this.handleChange}
              />{' '}
              {this.i18n('Other')}
            </label>
            <br />
          </div>
        ) : null}
        {foundDwelling === FOUND_NO_DWELLING ? (
          <div>
            <strong>{this.i18n('Hvorfor ønsker du at afmelde?')}</strong>
            <textarea
              name="reason"
              ref="reason"
              onChange={this.handleChange}
              className="form-control"
            />
            <button
              type="button"
              className="btn btn-danger pull-right btn-block"
              style={{ marginTop: '10px' }}
              onClick={this.handleSubmit}
            >
              {this.i18n('Unsubscribe')}
            </button>
          </div>
        ) : null}
        {/* TODO: Error/alert component */}
      </div>
    );
  }
}

export default Questionaire;
